import AxiosAuth from "../../services/axios-service";
import Config from "../../config";

const searchByKeyword = (keyword) => {
  return AxiosAuth.get(Config.API + "/api/search/" + keyword, undefined, undefined);
};

export default {
  searchByKeyword,
};